module.exports = __webpack_public_path__ + "img/auth-linkedin.a852160b.svg";